'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _types = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BodyWrapper = function (_React$Component) {
  _inherits(BodyWrapper, _React$Component);

  function BodyWrapper(props) {
    _classCallCheck(this, BodyWrapper);

    var _this = _possibleConstructorReturn(this, (BodyWrapper.__proto__ || Object.getPrototypeOf(BodyWrapper)).call(this, props));

    _this.ref = null;
    return _this;
  }

  _createClass(BodyWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      var _context = this.context,
          startHeight = _context.startHeight,
          endHeight = _context.endHeight,
          showExtraRow = _context.showExtraRow;

      var startRow = tr({
        key: 'start-row',
        style: {
          height: startHeight
        }
      });
      var endRow = tr({
        key: 'end-row',
        style: {
          height: endHeight
        }
      });
      // Extra row to keep onRow indexing stable instead of even/odd. This is important
      // for styling.
      var rows = [startRow].concat(children).concat(endRow);

      if (showExtraRow) {
        rows.unshift(tr({
          key: 'extra-row',
          style: {
            height: 0
          }
        }));
      }

      return _react2.default.createElement('tbody', _extends({}, props, {
        ref: function ref(e) {
          _this2.ref = e;
        }
      }), rows);
    }
  }, {
    key: 'getRef',
    value: function getRef() {
      return this.ref;
    }
  }]);

  return BodyWrapper;
}(_react2.default.Component);

BodyWrapper.contextTypes = _types.bodyWrapperContextTypes;
process.env.NODE_ENV !== "production" ? BodyWrapper.propTypes = _types.bodyWrapperTypes : void 0;

function tr(props) {
  return _react2.default.createElement('tr', props);
}

exports.default = BodyWrapper;